import View from '@/views/component/public/button/style';
import { EButton } from "@/interface/enum";

type IProp = {
  type: EButton,
  status?: 0 | 1 | 100
  [key: string]: any
}

function Index(props: IProp) {
  return (
    <View {...props}>
      {props.children}
    </View>
  );
}

export default Index
